/**
 * @deprecated Используйте useSubscriptions store из @/store/subscriptions
 * Этот файл оставлен для обратной совместимости.
 */

import axios from "axios";

// Реэкспорт утилит из store
export {
  importanceMapping,
  importanceMappingReverse,
  sentimentValues,
  periodToFrequency,
  frequencyToPeriod
} from "@/store/subscriptions";

const REPORTS_API_BASE = "/subscriptions";

export const subscriptionsApi = {
  async getSubscriptions(params = {}) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });
    
    const queryString = queryParams.toString();
    const url = `${REPORTS_API_BASE}/subscriptions${queryString ? `?${queryString}` : ""}`;
    const response = await axios.get(url);
    return response.data;
  },

  async verifySubscription() {
    const response = await axios.get(`${REPORTS_API_BASE}/verify`);
    return response.data;
  },

  async getSubscription(subscriptionId) {
    const response = await axios.get(`${REPORTS_API_BASE}/subscriptions/${subscriptionId}`);
    return response.data;
  },

  async createSubscription(data) {
    const response = await axios.post(`${REPORTS_API_BASE}/subscriptions`, data);
    return response.data;
  },

  async updateSubscription(subscriptionId, data) {
    const response = await axios.put(`${REPORTS_API_BASE}/subscriptions/${subscriptionId}`, data);
    return response.data;
  },

  async patchSubscription(subscriptionId, data) {
    const response = await axios.patch(`${REPORTS_API_BASE}/subscriptions/${subscriptionId}`, data);
    return response.data;
  },

  async deleteSubscription(subscriptionId) {
    await axios.delete(`${REPORTS_API_BASE}/subscriptions/${subscriptionId}`);
  },

  async unlinkTelegramChat() {
    await axios.post(`${REPORTS_API_BASE}/users/profile/chat-untying`);
  }
};

export default subscriptionsApi;
